export default __webpack_public_path__ + "static/8-cb97db8eef497a654fcd51338af0fb56.jpg";